export default "__VITE_ASSET__BsMG67et__"